import Vue from 'vue'
import Router from 'vue-router'
import Library from '@/library'
import store from '@/store'

import pluralize from 'pluralize'

import admin from './routes/admin'

Vue.use(Router)

const router = new Router({
  mode: 'history',

  linkExactActiveClass: 'is-active',

  routes: [
    {
      path: '',
      component: require('@/views/_Layouts/Guest.vue').default,
      children: [
        {
          path: '/',
          name: 'Admin',
          component: require('@/views/Landing.vue').default
        },

        ...Library.Router.Modules.Auth('Dashboard')
      ]
    },

    {
      path: '',
      component: require('@/views/_Layouts/Master.vue').default,
      children: [
        ...admin,

        {
          path: '/settings',
          name: 'Settings',
          component: require('@/views/User/Settings.vue').default
        }
      ],
      beforeEnter: Library.Router.Middleware.isLoggedIn(store, { name: 'Login' })
    },

    {
      path: '/404',
      alias: '*',
      component: require('@/views/NotFound.vue').default
    }
  ]
})

router.beforeEach((to, from, next) => {
  const title = to.name

  if (title) {
    if (title.startsWith('Search')) {
      document.title = pluralize(title)
    } else {
      document.title = title
    }
  } else {
    document.title = 'Admin'
  }

  next()
})

export default router
